// 깃허브풍 테마 색상 (Primer 근사치)
const GH_COLORS = {
  canvas: "#f6f8fa",
  canvasInset: "#f0f3f6",
  canvasBg: "#f6f8fa",
  border: "#d0d7de",
  subtleBorder: "#cbd5e1",
  fgDefault: "#24292f",
  fgMuted: "#57606a",
  fgOnEmphasis: "#ffffff",
  headerBg: "#24292f",
  headerBorder: "#1f2328",
  btnPrimaryBg: "#2ea44f",
  btnDangerBg: "#d73a49",
  btnMutedBg: "#6a737d",
  accentBg: "#0969da",
  selection: "#ddf4ff",
};

// 테이블 스타일 (깃허브 테이블 느낌)
const tableStyle: React.CSSProperties = {
  borderCollapse: "collapse",
  width: "100%",
  maxWidth: "100%",
  tableLayout: "auto",
  background: "#fff",
  border: `1px double #999`,
  borderRadius: 0,
  overflow: "hidden",
  marginBottom: "32px",
};

const thStyle: React.CSSProperties = {
  borderBottom: `1px solid ${GH_COLORS.border}`,
  background: GH_COLORS.headerBg,
  padding: "3px 6px",
  fontWeight: 600,
  color: GH_COLORS.fgOnEmphasis,
  textAlign: "center",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
  height: "20px",
  lineHeight: "1",
};

const pointThStyle: React.CSSProperties = {
  ...thStyle,
  position: "relative",
};

const tdStyle: React.CSSProperties = {
  padding: "3px 6px",
  textAlign: "center",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
  borderRight: `1px solid ${GH_COLORS.border}`,
  borderLeft: `1px solid ${GH_COLORS.border}`,
  height: "20px",
  lineHeight: "1",
};

const buttonStyle: React.CSSProperties = {
  minWidth: "44px",
  fontSize: "14px",
  padding: "6px 12px",
  borderRadius: 6,
  color: "#fff",
  border: `1px solid rgba(0,0,0,0.1)`,
  fontWeight: 600,
  cursor: "pointer",
  background: GH_COLORS.btnMutedBg,
};

const buttonBackgroundColor: { [key: string]: React.CSSProperties } = {
  save: { background: GH_COLORS.btnPrimaryBg },
  cancel: { background: GH_COLORS.btnMutedBg },
  edit: { background: "#dbab09" },
  delete: { background: GH_COLORS.btnDangerBg },
  success: { background: GH_COLORS.btnPrimaryBg },
};

const inputStyle: React.CSSProperties = {
  width: "160px",
  borderRadius: 6,
  border: `1px solid ${GH_COLORS.border}`,
  padding: "8px 10px",
  fontSize: "14px",
  textAlign: "left",
  background: "#fff",
  color: GH_COLORS.fgDefault,
};

const pageHeadingStyle: React.CSSProperties = {
  margin: "0 0 0 0",
  fontSize: "22px",
  fontWeight: 600,
  color: GH_COLORS.fgDefault,
};

const pageContainerStyle: React.CSSProperties = {
  padding: "10px 20px 10px 20px",
  boxSizing: "border-box",
  width: "100%",
};

// ===== TanStack Table 스타일 =====

// 포인트 편집 입력 필드
const pointInputStyle: React.CSSProperties = {
  width: "100%",
  padding: "0",
  margin: "0",
  borderRadius: 0,
  border: "2px solid #0969da",
  fontSize: 15,
  fontWeight: "normal",
  fontFamily: "inherit",
  textAlign: "center",
  height: "100%",
  boxSizing: "border-box",
  background: "#ffffff",
  outline: "none",
  lineHeight: "1",
};

// 포인트 표시 span (기본 상태)
const pointSpanStyle: React.CSSProperties = {
  cursor: "pointer",
  fontWeight: "normal",
  userSelect: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "6px 4px",
  margin: "0",
  width: "100%",
  boxSizing: "border-box",
  border: "2px solid transparent",
  transition: "all 0.1s ease",
  lineHeight: "1",
};

// 포인트 버튼 (동적 색상 처리)
const getPointButtonStyle = (score: number): React.CSSProperties => ({
  color: score < 0 ? "#d00" : "#060",
  fontWeight: "normal",
  width: "32px",
  height: "22px",
  fontSize: "15px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  background: "#f7f7f7",
  cursor: "pointer",
  padding: "0",
});

// 버튼 컨테이너
const buttonContainerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
};

// 팝오버 컨테이너
const popoverContainerStyle: React.CSSProperties = {
  backgroundColor: "#ffffff",
  borderRadius: 8,
  boxShadow: "0 8px 24px rgba(140,149,159,0.2)",
  padding: "12px 16px",
  minWidth: 180,
};

// 팝오버 제목
const popoverTitleStyle: React.CSSProperties = {
  marginBottom: 12,
  fontSize: 15,
  fontWeight: 600,
  color: "#24292f",
};

// 팝오버 옵션 컨테이너
const popoverOptionsContainerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
};

// 팝오버 라벨
const popoverLabelStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  cursor: "pointer",
  fontSize: 15,
  color: "#24292f",
};

// 팝오버 버튼 컨테이너
const popoverButtonsContainerStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 8,
  marginTop: 12,
  paddingTop: 12,
  borderTop: "1px solid #d0d7de",
};

// 팝오버 취소 버튼
const popoverCancelButtonStyle: React.CSSProperties = {
  padding: "6px 12px",
  borderRadius: 6,
  border: "1px solid #d0d7de",
  background: "#f6f8fa",
  fontSize: 15,
  cursor: "pointer",
  color: "#24292f",
  fontWeight: 500,
};

// 팝오버 확인 버튼
const popoverConfirmButtonStyle: React.CSSProperties = {
  padding: "6px 12px",
  borderRadius: 6,
  border: "1px solid #1f883d",
  background: "#1f883d",
  color: "#fff",
  fontSize: 15,
  cursor: "pointer",
  fontWeight: 500,
};

// TanStack Table 스타일
const tanstackTableStyle: React.CSSProperties = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: 15,
  border: "1px solid #d0d7de",
  tableLayout: "fixed",
};

// TanStack Table 헤더 (동적 스타일)
const getTanstackThStyle = (isPointColumn: boolean, headerSize: number, additionalStyle?: any): React.CSSProperties => ({
  ...(isPointColumn ? additionalStyle : {}),
  padding: "6px 4px",
  textAlign: "center",
  verticalAlign: "middle",
  borderBottom: "1px solid #d0d7de",
  borderRight: "1px solid #d0d7de",
  background: "#24292f",
  fontWeight: 600,
  fontSize: 15,
  color: "#ffffff",
  position: "sticky",
  top: 0,
  zIndex: 2,
  width: headerSize,
  minWidth: headerSize,
  maxWidth: headerSize,
});

// 정렬 헤더
const sortHeaderStyle: React.CSSProperties = {
  cursor: "pointer",
  userSelect: "none",
};

// 정렬 화살표
const sortArrowStyle: React.CSSProperties = {
  fontSize: "15px",
  marginLeft: 4,
};

// 필터 컨테이너
const filterContainerStyle: React.CSSProperties = {
  marginTop: 4,
};

// TanStack Table 행
const tanstackTrStyle: React.CSSProperties = {
  borderBottom: "1px solid #d0d7de",
};

// TanStack Table 셀 (동적 스타일)
const getTanstackTdStyle = (isEditableCell: boolean, cellSize: number): React.CSSProperties => ({
  padding: isEditableCell ? "0" : "4px 6px",
  fontSize: 15,
  color: "#24292f",
  verticalAlign: "middle",
  textAlign: "center",
  borderRight: "1px solid #d0d7de",
  width: cellSize,
  minWidth: cellSize,
  maxWidth: cellSize,
});

// 클릭 가능한 셀 내용
const clickableCellStyle: React.CSSProperties = {
  cursor: "pointer",
};

// 빈 행 스타일
const emptyRowStyle: React.CSSProperties = {
  padding: "20px",
  textAlign: "center",
  color: "#656d76",
};

// 안내 텍스트
const infoTextStyle: React.CSSProperties = {
  fontSize: 15,
  color: "#656d76",
  margin: 0,
};

export {
  tableStyle,
  thStyle,
  pointThStyle,
  tdStyle,
  buttonStyle,
  buttonBackgroundColor,
  inputStyle,
  pageHeadingStyle,
  pageContainerStyle,
  GH_COLORS,
  // TanStack Table 스타일
  pointInputStyle,
  pointSpanStyle,
  getPointButtonStyle,
  buttonContainerStyle,
  popoverContainerStyle,
  popoverTitleStyle,
  popoverOptionsContainerStyle,
  popoverLabelStyle,
  popoverButtonsContainerStyle,
  popoverCancelButtonStyle,
  popoverConfirmButtonStyle,
  tanstackTableStyle,
  getTanstackThStyle,
  sortHeaderStyle,
  sortArrowStyle,
  filterContainerStyle,
  tanstackTrStyle,
  getTanstackTdStyle,
  clickableCellStyle,
  emptyRowStyle,
  infoTextStyle,
};